import cx from 'classnames';
import {FocusTrap} from 'focus-trap-react';
import {PanelHeaderRow} from '../atoms/PanelHeaderRow';
import {useIsLargeAndUp} from '../hooks/useMatchQuery';

export const SlideoutPanel = ({
  isOpen,
  onClose,
  direction = 'right',
  showHeader = true,
  showTitle = true,
  title,
  qaId = 'slideout_panel',
  modalId,
  closeQaId,
  showCover,
  trapFocus = true,
  focusTrapPaused = false,
  fallbackFocus,
  backArrow,
  children,
  className,
  titleVariant = 'list2',
  disableOverlayClick = false,
  style,
}) => {
  const isLargeAndUp = useIsLargeAndUp();

  return (
    <>
      <button
        className={cx('transparent', 'slideout-panel-overlay', {
          'panel-open': isOpen,
          'show-cover': showCover,
        })}
        onClick={() => {
          if (!disableOverlayClick) {
            onClose();
          }
        }}
        data-qa-id={closeQaId || `${modalId}-header`}
        type="button"
      />
      <FocusTrap
        active={trapFocus && isOpen}
        paused={focusTrapPaused}
        focusTrapOptions={{
          allowOutsideClick: true,
          fallbackFocus,
        }}
      >
        <div
          data-qa-id={qaId}
          className={cx(className, 'slideout-panel-content', {
            'slideout-panel-content--right': direction === 'right',
            'slideout-panel-content--mobile': !isLargeAndUp,
            'slideout-panel-content--left--mobile': direction === 'left' && !isLargeAndUp,
            close: !isOpen,
            open: isOpen,
          })}
          style={style}
        >
          {showHeader && (
            <PanelHeaderRow
              title={title}
              showTitle={showTitle}
              onClose={onClose}
              qaId={`${modalId}-header`}
              backArrow={backArrow}
              titleVariant={titleVariant}
            />
          )}
          {children}
        </div>
      </FocusTrap>
    </>
  );
};
